<template>
    <span>
        <FormsAutocomplete 
            v-model="model"  
            :item="collection"
            :label="label"
            :disabled="disabled"
            :error-messages="errorMessages"
            :dense="dense"
        />
    </span>
  </template>
  
  <script setup>
  
  import { ref, computed, defineEmits, defineProps } from 'vue'
  
  //Events
  const emit = defineEmits(['input'])
  
  //Props
  const props = defineProps({
        label: { type: String, default: 'Ambiente*'},
        disabled: { type: Boolean, required: false },
        dense: { type: Boolean, required: false },
        value: { type: [String, Number, Object, Array] },
        errorMessages: { type: Array, required: false },
    })
  
  //Computed
  const model = computed({
    get: () => props.value,
    set: val => emit('input', val)
  })
  
  const collection = ref([
        { id: 'local', name: 'Desenvolvimento'},
        { id: 'production', name: 'Produção' },
        { id: 'staging', name: 'Teste' },
    ])
  
  </script>